import React from "react";
import { Link } from "gatsby";
import { ArrowUpRight } from "lucide-react";
import { PUBLIC_CONTACT } from "@/data/public-contact";

const Footer = () => {
  return (
    <footer className="border-t border-border">
      <div className="container-asymmetric py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <p className="font-display text-lg font-medium mb-4">
              Mohammed Sagban
            </p>
            <p className="body-small text-muted-foreground max-w-xs">
              Striving for the ideal—in thinking, in structure, in what we build.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="caption text-muted-foreground mb-4">Navigation</p>
            <ul className="space-y-2">
              {[
                { name: "Experience", path: "/experience" },
                { name: "Projects", path: "/projects" },
                { name: "Blog", path: "/blog" },
                { name: "Now", path: "/now" },
                { name: "Resume", path: "/resume" },
                { name: "Contact", path: "/contact" },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="link-hover text-sm opacity-80 hover:opacity-100 transition-opacity"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <p className="caption text-muted-foreground mb-4">Connect</p>
            <ul className="space-y-2">
              {[
                {
                  name: "Website",
                  url: PUBLIC_CONTACT.site.url,
                },
                { name: "GitHub", url: PUBLIC_CONTACT.github.url },
                { name: "LinkedIn", url: PUBLIC_CONTACT.linkedin.url },
                { name: "X", url: PUBLIC_CONTACT.x.url },
                { name: "Email", url: `mailto:${PUBLIC_CONTACT.email}` },
              ].map((item) => (
                <li key={item.name}>
                  <a
                    href={item.url}
                    className="inline-flex items-center gap-1 text-sm opacity-80 hover:opacity-100 transition-opacity group"
                    target={
                      item.url.startsWith("http") ? "_blank" : undefined
                    }
                    rel={
                      item.url.startsWith("http")
                        ? "noopener noreferrer"
                        : undefined
                    }
                  >
                    {item.name}
                    <ArrowUpRight
                      size={12}
                      className="opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="divider my-12" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-muted-foreground" suppressHydrationWarning>
            © {new Date().getFullYear()} Mohammed Sagban
          </p>
          <p className="text-xs text-muted-foreground">
            Designed and developed by Mohammed Sagban
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
